<template>
  <div class="ant-set">
    <el-drawer
      v-model="drawerVisible"
      append-to-body
      class="ant-set-drawer"
      direction="rtl"
      size="480px"
      :title="drawerCoreInfo?.title"
    >
      <template #header>
        <div class="ant-set__header-icon-wrap">
          <img class="ant-set__header-icon" :src="drawerCoreInfo?.icon" />
        </div>
        <div class="ant-set__header-content">
          <h2 class="ant-set__title">{{ drawerCoreInfo?.title }}</h2>
          <!-- 状态 如果状态为2且存在时间则显示已开通 -->

          <div class="status" :class="{ 'is-active': drawerCoreInfo?.endTime }">
            {{
              drawerCoreInfo?.endTime
                ? xbb.formatTime(drawerCoreInfo?.endTime, 'yyyy-MM-dd') + ' 到期'
                : ''
            }}
          </div>
        </div>
      </template>
      <!-- 抽屉主体 -->
      <div v-loading="drawerLoading" class="ant-set__main">
        <el-scrollbar>
          <div class="ant-set__main-title">
            <div class="prefix-block"></div>
            <div class="text">使用范围</div>
          </div>
          <div class="ant-set__main-desc">
            <div class="required">*</div>
            <div class="title">给哪些员工分配账号</div>
            <div class="subfix">（{{ userRange.length }}/{{ total }}）</div>
          </div>
          <div class="ant-set__main-subdesc">
            {{ tips }}
          </div>
          <div class="ant-set__main__permission" @click.stop="personSelectVisible = true">
            <div class="ant-set__main__permission-text">
              <template v-if="userRange.length">
                <el-tag
                  v-for="tag in userRange"
                  :key="tag.id"
                  closable
                  :disable-transitions="true"
                  size="mini"
                  type="info"
                  @close="handleRemoveArr(tag.id)"
                >
                  {{ tag.name }}
                </el-tag>
              </template>
              <div v-else class="placeholder">请选择员工</div>
            </div>
            <i class="ant-set__main__permission-btn icon-arrow-down-s-line t-iconfont"></i>
          </div>
        </el-scrollbar>
      </div>
      <div class="ant-set__footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button :loading="saveLoading" type="primary" @click="handleSubmit"
          >保存并生效</el-button
        >
      </div>
    </el-drawer>
    <PersonSelect
      v-model="userRange"
      v-model:show="personSelectVisible"
      :max="total"
      :show-department="false"
    />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { getAntAccessUseList, assignAntAccess } from '@/api/ai-setting'
import xbb from '@xbb/xbb-utils'
import PersonSelect from '@/components/ai-person-select-v2/person-select.vue'

const emit = defineEmits(['update:antDrawerVisible', 'change'])
const props = defineProps({
  antDrawerVisible: {
    type: Boolean,
    required: true
  },
  drawerCoreInfo: {
    type: Object,
    required: true
  }
})

const tips = computed(() => {
  // 蚂蚁找客 且开通正常
  if (props.drawerCoreInfo?.alias === 'myzkAssistant') {
    return '新授权成员的推荐模型初始化，预计次日完成。为确保数据精准，请于明日通知相关人员开始使用。'
  }
  // 已过期、已开通的标讯助手都是空
  return ''
})

const drawerVisible = computed({
  get() {
    return props.antDrawerVisible
  },
  set(value) {
    emit('update:antDrawerVisible', value)
  }
})

watch(
  () => props.antDrawerVisible,
  (newVal) => {
    if (newVal) {
      // 打开抽屉时获取已分配账号列表
      drawerLoading.value = true
      userRange.value = []

      getAntAccessUseList({ feeType: props.drawerCoreInfo.feeType })
        .then((res) => {
          userRange.value = res.result.list || []
          total.value = res.result.total || 0
        })
        .finally(() => {
          drawerLoading.value = false
        })
    }
  }
)

const userRange = ref([])
const personSelectVisible = ref(false)
const drawerLoading = ref(false)
const saveLoading = ref(false)
const total = ref(2)

const handleSubmit = () => {
  const ids = userRange.value.map((item) => item.id)
  saveLoading.value = true
  assignAntAccess({
    feeType: props.drawerCoreInfo?.feeType,
    userList: ids
  })
    .then(() => {
      ElMessage.success('保存成功')
      drawerVisible.value = false
      emit('change', userRange.value)
    })
    .catch(() => {})
    .finally(() => {
      drawerLoading.value = false
      saveLoading.value = false
    })
}

// 使用范围tag点击指定删除
const handleRemoveArr = (id) => {
  userRange.value = userRange.value.filter((i) => i.id !== id)
}
</script>

<style lang="scss">
.ant-set-drawer {
  .status {
    margin-top: 4px;
    display: inline-flex;
    align-items: center;
    background: #f2f3f5;
    padding: 4px 8px;
    border-radius: 8px;
    /* 六级文字/常规 */
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0em;
    color: #646566;
    &::before {
      display: inline-block;
      width: 4px;
      height: 4px;
      content: '';
      background: #646566;
      border-radius: 50%;
      margin-right: 4px;
    }

    &.is-active::before {
      background: #00c241;
    }
  }
  .ant-set__header-icon-wrap {
    flex: 0 0 auto !important;
    width: 40px;
    height: 40px;
    margin-right: 12px;
    position: relative;
  }

  .ant-set__header-icon {
    width: 100%;
    height: 100%;
  }

  .ant-set__header-content {
    flex: 1;
  }

  .ant-set__title {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    color: #323233;
  }
  .ant-set__main {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-top: 1px solid #f2f3f5;
    .ant-set__main-title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .prefix-block {
        width: 4px;
        height: 16px;
        border-radius: 4px;
        background: #7a52f4;
        margin-right: 8px;
      }
      .text {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #323233;
      }
    }
    .ant-set__main-desc {
      display: flex;
      font-family: PingFang SC;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 4px;
      .required {
        color: #f54e4e;
      }
      .title {
        color: #323233;
      }
      .subfix {
        color: #969799;
      }
    }
    .ant-set__main-subdesc {
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      color: #9e9e9e;
    }
    .ant-set__main__permission {
      display: flex;
      width: 100%;
      overflow: hidden;
      background: #fff;
      border: 1px solid #e5e6eb;
      border-radius: 8px;
      margin-bottom: 16px;
      .ant-set__main__permission-text {
        .placeholder {
          margin-left: 8px;
          margin-top: 2px;
          /* 四级文字/常规 */
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: normal;
          line-height: normal;
          display: flex;
          align-items: center;
          letter-spacing: 0em;

          /* 文字/Text-1 置灰信息 */
          /* 样式描述：$text-grey */
          color: #c8c9cc;
        }
        .el-tag {
          margin-right: 4px;
          margin-bottom: 4px;
        }
        box-sizing: border-box;
        display: block;
        flex: 1;
        min-height: 32px;
        max-height: 96px;
        height: auto;
        padding: 4px 4px 0 4px;
        overflow-y: auto;
        cursor: pointer;
      }
      .ant-set__main__permission-btn {
        display: flex;
        align-items: center;
        margin: 0 12px 0 8px;
      }
    }
  }
  .ant-set__footer {
    flex: 0 0 auto;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: end;
    .el-button {
      border-radius: 8px;
    }
  }
  .ant-set__item {
    height: 400px;
  }
  .el-drawer__body {
    display: flex;
    flex-direction: column;
  }
  .el-scrollbar__view {
    padding: 16px;
  }
}
</style>
